import '../social_content_parent_post_view.js.coffee'
Monitoring.Views ||= {}

class Monitoring.Views.InstagramContentParentStoryView extends Monitoring.Views.SocialContentParentPostView

  buildQuery: =>
    @searchQuery = new Monitoring.Models.SearchQuery({}, { use_defaults: false })
    @searchQuery.addContextKind('ig_story')
    @addContextLimit()
    # @rootParentId is the complete ID, I need only the content ID
    @searchQuery.addContentId(@rootParentId.split('-')[0])
